import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = ({ 
  title, 
  breadcrumb = [], 
  background = '/assets/images/banner.jpg',
  overlay = true,
  children 
}) => {
  return (
    <section className="bg-blue-900">
      <div 
        className={`relative py-20 bg-cover bg-center ${overlay ? 'bg-opacity-80 bg-blue-900' : ''}`}
        style={{ backgroundImage: `url(${background})` }}
      >
        <div className="absolute inset-0 bg-blue-900 opacity-70"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">{title}</h1>
            
            {breadcrumb.length > 0 && (
              <nav className="flex justify-center">
                <ol className="flex items-center space-x-2">
                  <li>
                    <Link to="/" className="text-gray-200 hover:text-white transition-colors">
                      Home
                    </Link>
                  </li>
                  
                  {breadcrumb.map((item, index) => (
                    <li key={index} className="flex items-center">
                      <span className="mx-2">/</span>
                      {item.url ? (
                        <Link 
                          to={item.url} 
                          className="text-gray-200 hover:text-white transition-colors"
                        >
                          {item.name}
                        </Link>
                      ) : (
                        <span className="text-white">{item.name}</span>
                      )}
                    </li>
                  ))}
                </ol>
              </nav>
            )}
            
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;